module.exports = __webpack_public_path__ + "img/solares.ff4913ba.png";